export enum EstatusTicketEnum {
    ABIERTA = 'ABIERTA',
    PROCESO = 'PROCESO',
    ATENDIDA = 'ATENDIDA',
    VOBO = 'VOBO',
    CANCELADA = 'CANCELADA',
    REABIERTA = 'REABIERTA'
}

export class EstatusTicket {
    public static obtenerValor (valor: string) {
        valor = (valor === null || valor === undefined) ? '' : valor;
        switch (valor) {
            case 'ABIERTA': return 1;
            case 'PROCESO': return 2;
            case 'ATENDIDA': return 3;
            case 'VOBO': return 4;
            case 'CANCELADA': return 5;
            case 'REABIERTA': return 6;
        }
        return 0;
    }
}
